module.exports = __webpack_public_path__ + "img/utility-pole-double.529845d4.svg";